// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "e96737be4abf909420f9" + "/js/" + chunkId + ".js";
};